import { ACTION_CONSTANTS } from 'actions/constants';

const INITIAL_STATE = {};

export function config(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.config.get:
      return action.payload.config;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/api/config.js